import { useState, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

let msgCounter = 0;
const makeMessage = (role, content) => ({ id: `msg_${++msgCounter}_${Date.now()}`, role, content });

export const useChat = () => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sessionId] = useState(() => `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`);
  const [clientInfo, setClientInfo] = useState({ name: '', email: '', phone: '' });

  const addGreeting = useCallback(() => {
    setMessages((prev) =>
      prev.length === 0
        ? [makeMessage('assistant', 'GENSOL, los expertos del puerto. ¿En qué puedo ayudarte el día de hoy?')]
        : prev
    );
  }, []);

  const sendMessage = useCallback(
    async (text) => {
      const userMessage = text.trim();
      if (!userMessage) return;

      setMessages((prev) => [...prev, makeMessage('user', userMessage)]);
      setIsLoading(true);
      try {
        const response = await axios.post(`${API_URL}/api/chat/message`, {
          session_id: sessionId,
          message: userMessage,
          client_name: clientInfo.name || null,
          client_email: clientInfo.email || null,
          client_phone: clientInfo.phone || null,
        });
        setMessages((prev) => [...prev, makeMessage('assistant', response.data.response)]);
      } catch (error) {
        setMessages((prev) => [
          ...prev,
          makeMessage('assistant', 'Lo siento, hubo un error. Por favor contacta directamente al 229 921 23 32.'),
        ]);
      } finally {
        setIsLoading(false);
      }
    },
    [sessionId, clientInfo]
  );

  const endChat = useCallback(async () => {
    setIsLoading(true);
    try {
      await axios.post(`${API_URL}/api/chat/end`, {
        session_id: sessionId,
        client_name: clientInfo.name || 'No proporcionado',
        client_email: clientInfo.email || 'No proporcionado',
        client_phone: clientInfo.phone || 'No proporcionado',
      });
      setMessages((prev) => [
        ...prev,
        makeMessage(
          'assistant',
          '¡Gracias por contactarnos! Tu conversación ha sido enviada a nuestro equipo. Nos pondremos en contacto contigo pronto. ¡Que tengas un excelente día!'
        ),
      ]);
      return true;
    } catch (error) {
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [sessionId, clientInfo]);

  return { messages, isLoading, clientInfo, setClientInfo, addGreeting, sendMessage, endChat };
};
